import { roles } from '@nxsys/store/constants';
import AEPNListing from '../../../modules/aepn/listing';

export const aepnConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/aepn',
    element: <AEPNListing />,
  },
];
